import Axios from 'axios'

const urlBack = process.env.VUE_APP_PLATAFORMA_URL

const documentsService = {
  encrypt: async text => {
    const response = await Axios.get('/prontuario/encrypt', {
      params: { text }
    })

    return response.data
  },
  getUrlAso: async (id, pathParam = '') => {
    const textEncrypted = await documentsService.encrypt(id)
    return `${urlBack}/aso/${textEncrypted}${pathParam}`
  },
  getUrlGuia: async (id, pathParam = '') => {
    const textEncrypted = await documentsService.encrypt(id)
    return `${urlBack}/guia/${textEncrypted}${pathParam}`
  }
}

export default documentsService
